<template>
    <div>
        <hos_apply_title :title="state == 'REFUSED' ? '拒绝原因' : '取消原因' "></hos_apply_title>
        <div class="mt20 content">
            <slot name="cancle_content"></slot>
        </div>
    </div>
</template>

<script>
    import hos_apply_title from './hos-apply-title'
    export default {
        name: "hos-cancle-info-detail",
        props:{
            state:{
                type:String
            }
        },
        components:{
            hos_apply_title
        }
    }
</script>

<style lang="scss" scoped>
.content{
    background: #F5F5F5;
    border: 1px solid #E8E8E8;
    border-radius: 4px;
    font-family: PingFangSC-Regular;
    font-size: 14px;
    color: #FF0000;
    letter-spacing: 0;
    line-height: 14px;
}
</style>